import { useQuery } from "@tanstack/react-query";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";


export const useWebsitePackages = (companyId, type = "Holiday") => {
   const { user } = useAuth();
  const activeCompanyId = companyId || user?.cid;
  const queryFn = async () => {
    const response = await apiService.getAll(
      `${config.GETPACKAGEBYCOMAPANYID}/${activeCompanyId}?type=${type}`
    );
    console.log("API Response for Website Packages:", response);
    return response.data || response;
  };

  return useQuery({
    queryKey: ["website-packages", activeCompanyId, type],
    queryFn,
    enabled: !!activeCompanyId,
    staleTime: 1000 * 60 * 5,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};